import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="text-gray-900">
      <h1 className="mb-1 text-xl font-semibold md:text-2xl">Privacy Policy</h1>

      <section className="space-y-4 text-sm leading-6 text-gray-800">
        <p>
          411 Group processes personal and business information to operate and improve the Platform,
          provide services, support users, and meet legal/programme obligations. We process data
          under lawful bases recognised by the Botswana Data Protection Act (2018), POPIA, and GDPR
          (where applicable).
        </p>

        <div>
          <h2 className="mb-1 font-semibold">Data We Collect</h2>
          <p>
            Account details, contact information, profile and programme data, usage/analytics, and
            communications.
          </p>
        </div>

        <div>
          <h2 className="mb-1 font-semibold">How We Use Data</h2>
          <p>
            Service delivery, training/coaching, monitoring & evaluation, security, compliance, and
            communications.
          </p>
        </div>

        <div>
          <h2 className="mb-1 font-semibold">Sharing</h2>
          <p>
            With programme partners and service providers under contracts and safeguards; as
            required by law.
          </p>
        </div>

        <div>
          <h2 className="mb-1 font-semibold">Retention</h2>
          <p>
            For as long as needed for the purposes above and to meet legal/reporting requirements,
            then securely deleted or anonymised.
          </p>
        </div>

        <div>
          <h2 className="mb-1 font-semibold">Your Rights</h2>
          <p>
            Depending on jurisdiction: access, rectification, deletion, restriction, objection,
            portability. Contact us to exercise rights.
          </p>
        </div>

        <div>
          <h2 className="mb-1 font-semibold">Contact</h2>
          <p>
            411 Group of Investments (Pty) Ltd
            <br />
            P O Box 99 Lentswe-le-Moriti, Tuli Block, Botswana
            <br />
            Email: info@411group.co.bw
          </p>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
